<script>
  import { layoutMethods, customerLiteMethods, customerListLiteComputed, exportMethods,erpFixMessages} from "@/state/helpers";
  import flatPickr from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import Swal from 'sweetalert2';

  /**
   * Topup Transaction component
   */
  export default {
    page: {
      title: "Topup Transaction"
    },
    components: {
      flatPickr
    },
    computed: {
      ...customerListLiteComputed,
      ...erpFixMessages,
    },
    data() {
      return {
        title: "Topup Transaction",
        searchValue: {
          searchField: null,
          search: "",
          status: null,
          dateRange: null,
          sort: 'id',
          orderDesc: true,
          page: 1,
          rows: 10,
          payment_method:null,
          business_id:null,
        },
        searchList: [
          { text: "Search All", value: null },
          { text: "Transaction ID", value: "transaction_id" },
          { text: "Customer Name", value: "name" },
          { text: "Wallet", value: "wallet" },
        ],
        fields: [
          {key: "transactionId", sortable: true},
          {key: "customerName", sortable: true},
          {key: "paymentStatus", sortable: true},
          {key: "wallet", sortable: true},
          {key: "paymentMethod", sortable: true},
          {key: "amount", sortable: true},
          {key: "date", sortable: true},
        ],
        pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
        sortBy: "value",
        sortDesc: false,
        rangeOptions: {
          mode: "range",
        },
        statusOption: [
          { text: "All", value: null },
          { text: "Success", value: "success" },
          { text: "Pending", value: "pending" },
          { text: "Failed", value: "failed" }
        ],
      };
    },
    methods: {
      ...layoutMethods,
      ...customerLiteMethods,
      ...exportMethods,
      async onSearch(state = ''){
          console.log("onsearch",JSON.stringify(this.searchValue));
          if(state == 'reset'){
            this.searchValue.page = 1;
          }
          await this.getEloadTopupLogs({...this.searchValue})
      },
      async onExport(){
        await this.onSearch('reset');
        if(this.eloadTopupLogsTotalRows ==0){
          Swal.fire("Failed!", this.exportNullPrompt, "warning");
          return;
        }
        let params = Object.assign(
          // this.searchValue,
          {
            module: 'eload_transactions',
            email: JSON.parse(localStorage.getItem('userData')).email,
            "orderDesc": this.searchValue["orderDesc"],
            "sort": this.searchValue["sort"],
            "dateRange": this.searchValue["dateRange"],
            "status": this.searchValue["status"],
            "search": this.searchValue["search"],
            "searchField": this.searchValue["searchField"],
            "payment_method": this.searchValue["payment_method"],
            "business_id": this.searchValue["business_id"],
          });

        // delete params.page;
        // delete params.rows;

        // Use exportReportExt (/v1/others) which routes to the ERPAPI2 TriggersExportModule (triggers/export.js
        // handles module 'eload_transactions'). exportReport (/v1/core) does NOT reach that lambda.
        this.exportReportExt(params)
          .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
          .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));

      },
      tableSort(ctx){//context
        this.searchValue.sort = ctx.sortBy;
        this.searchValue.orderDesc = ctx.sortDesc;
        console.log(">> sorting...",ctx);
        this.onSearch('reset');
      },
      getStatusClassColor(data) {
        return data === 'FAILED' ? 'text-danger fw-medium m-0' : data === 'SUCCESS' ? 'text-success fw-medium m-0' : 'text-warning fw-medium m-0'; 
      },
    },
    async mounted(){
      this.searchValue.business_id = this.$route.params.bid;
      await this.onSearch('reset');
    }
  }
    
</script>

<template>
  <div><!-- outer div-->
    <div><!--transaction total indicator-->
      <span class="float-start fw-bold mt-3">
        {{eloadTopupLogsTotalRows}} Record(s)
      </span>
      <div class="mb-2 d-flex flex-wrap flex-row-reverse">
        <button class="btn btn-secondary" @click="onSearch">
          <feather type="refresh-ccw" size="16" class="icon nav-icon me-2"></feather>Refresh
        </button>
      </div>
    </div><!--transaction total indicator-->
    <div><!--transaction filter options-->
      <div class="d-flex flex-wrap mt-4 mb-2">
        <div class="me-2 ta-right">
          <b-form-group description="Search Keyword">
            <form class="d-flex" @submit.prevent="onSearch('reset')">
              <b-form-group id="input-group-3" label-for="input-3">
                <b-form-select
                  class="form-select rounded-0 rounded-start shadow-none"
                  id="input-3"
                  v-model="searchValue.searchField"
                  :options="searchList"
                ></b-form-select>
              </b-form-group>

              <b-input-group>
                <b-form-input
                  class="rounded-0"
                  v-model="searchValue.search"
                ></b-form-input>
              </b-input-group>
            </form>
          </b-form-group>
        </div>
        <div class="me-2 ta-right">
          <b-form-group label-for="status" description="Filter by Status">
            <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:160px"
              id="Status"
              v-model="searchValue.status"
              :options="statusOption"
            ></b-form-select>
          </b-form-group>
        </div>
        <div class="me-2 ta-right">
          <b-form-group description="Filter by Date Transaction">
            <flat-pickr
              v-model="searchValue.dateRange"
              :config="rangeOptions"
              placeholder="Select a date range"
              class="form-control"
              style="width: fit-content"
            ></flat-pickr>
          </b-form-group>
        </div>
        <div class="me-2">
          <a class="btn btn-primary h-fit" @click="onSearch('reset')">
            <i class='bx bx-search bx-fw'></i>Search
          </a>
        </div>
        <div class="me-2">
          <a href="javascript:void(0);" class="btn btn-primary me-2" @click="onExport">
            <i class="uil uil-export me-1"></i>
            Export
          </a>
        </div>
      </div>
    </div><!--transaction filter options-->
    <div><!--transaction display-->
      <div class="table-responsive">
        <div class="table align-middle table-nowrap">
          <b-table
            :items="eloadTopupLogs"
            :fields="fields"
            responsive="sm"
            :current-page="searchValue.page"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            class="table-check"
            @sort-changed="tableSort" 
          >
              <template #cell(customerName)="data">
                <span class="text-body fw-medium m-0">{{
                  data.item.customerInfo.name
                }}</span>
              </template>
              <template #cell(wallet)="data">
                <!-- Lite top-ups credit the Digital Product (eload) wallet; the log's wallet column is often
                     empty, so fall back to "Digital Product" to match the reason-log label convention. -->
                <span class="text-body fw-medium m-0">{{
                  data.item.wallet ? data.item.wallet : "Digital Product"
                }}</span>
              </template>
              <template #cell(paymentStatus)="data">
                <p class="text-body m-0">
                  <span :class="getStatusClassColor(data.item.status.toUpperCase())"> {{  data.item.status.toUpperCase()}}  </span>
                </p>
              </template>
              <template #cell(amount)="data">
                <p class="text-body text-end m-0">
                  PHP {{ data.item.amount | numberWithCommas }}
                </p>
              </template>
              <template #cell(date)="data">
                <p class="text-body m-0">
                  {{ data.item.date | formatDate }}
                </p>
              </template>
          </b-table>
        </div>
      </div>
      <!-- end table responsive -->
      <div class="row g-0 text-center" v-if="eloadTopupLogsTotalRows == 0">
        <span>No data to display.</span>
      </div><div class="p-1"></div>

      <div class="row" v-if="eloadTopupLogsTotalRows != 0 && eloadTopupLogsTotalRows > 10">
        <div class="col">
          <div class="form-group row pull-left">
            <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
            <div class="col-sm-6">
              <b-form-group label-for="display-record">
                <b-form-select class="form-select shadow-none w-fit"
                  id="display-record"
                  v-model="searchValue.rows"
                  :options="pageOptions"
                  @change="onSearch('reset')"
                ></b-form-select>
              </b-form-group>
            </div>
          </div>
          <div
            class="
              dataTables_paginate
              paging_simple_numbers
              float-end
            "
            v-if="eloadTopupLogsTotalRows > searchValue.rows"
          >
            <b-pagination
              class="pagination-rounded"
              v-model="searchValue.page"
              :total-rows="eloadTopupLogsTotalRows"
              @input="onSearch()"
              :per-page="searchValue.rows"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div><!--transaction display-->
  </div> <!-- end of outer div-->
</template>

<style>
</style>